import React from 'react'
import { Switch } from '../../common/components/switch'

export const DataFieldSwitch = function ({ selectedValue, dataKey, label, onChange, isDisabled = false }) {
  return (
    <div className="data-field-switch" data-qa={`data-field-switch-${dataKey}`}>
      {label && (
        <div className="form-element-label-medium">
          {label}
        </div>
      )}
      <Switch isOn={!!selectedValue} onToggle={(event) => onChange(!!event.target.checked)} isDisabled={isDisabled} />
    </div>
  )
}
